
<div id="app-community-discussionsd" class="container d-flex flex-column flex-grow-1 mt-5 pt-4 pb-4 h-100" role="main" [attr.aria-label]="('COMMUNITY' | translate)">
  <app-headline [type]="'h4'" [class]="'text-muted fw-bold mb-2'" [title]="('COMMUNITY' | translate)"></app-headline>
  @if (!(loadingService.loadingIndicator$ | async)) {
    <!-- IF NO DISCUSSIONS -->
    @if (true) {
      <div class="card mb-3">
        <div class="card-body p-0">
          <div class="card border-0 box-shadow-bottom">
            <div class="card-body text-center p-4">
              <div class="my-3">
                <div class="no-content-large-icon bg-warning rounded-circle d-flex justify-content-center align-items-center mx-auto">
                  <app-icon-badge [style]="'noContent'" [icon]="'comment'"></app-icon-badge>
                </div>
                <app-headline [type]="'h5'" [class]="'card-title mt-3'" [title]="'COMMUNITYNODISCUSSIONS' | translate"></app-headline>
              </div>
              <div class="fade-card d-flex align-items-center gap-2 p-2 mt-5 rounded-3 shadow-sm bg-light border flex-wrap">
                <app-icon-badge [style]="'default'" [icon]="'comment'" [fontSize]="'fs-5'" [fontColor]="'text-warning'"></app-icon-badge>
                <div class="d-flex flex-column text-start flex-grow-1">
                  <app-headline [type]="'h6'" [class]="'fw-bold text-muted'" [title]="'COMMUNITYCREATEDISCUSSIONTITLE' | translate"></app-headline>
                  <app-content [fontSize]="'fs-default'">{{ 'COMMUNITYSTARTYOURFIRSTDISCUSSIONNOW' | translate }}</app-content>
                </div>
                <div class="d-flex justify-content-end w-only-sm-100">
                  <app-form-button [text]="'START' | translate" (click)="createDiscussion()" [cssClass]="'e-primary fw-semibold'"></app-form-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }

  <div class="card mb-3">
    <div class="card-body">
      <!-- Search Bar -->
      <div class="d-flex align-items-center gap-2">
        <div class="flex-grow-1">
          <app-form-input [type]="'search'" [hasErrorField]="false" [placeholder]="('COMMUNITYSSEARCHPLACEHOLDER' | translate)" [iconFront]="'search'" [iconBack]="'close'" [iconClickType]="'back'" [fCN]="'searchString'" [fG]="communityDiscussionForm"></app-form-input>
        </div>
      </div>
      <!-- No search result text -->
      <div class="pt-1">
        <app-headline [title]="('NOSEARCHRESULTS' | translate)" [type]="'h6'" [class]="'text-center text-secondary'"></app-headline>
      </div>
      <!-- Result text -->
      <div class="d-flex align-items-center gap-1 pt-3">
        <app-headline [title]="'25'" [type]="'h6'" [class]="'text-secondary fw-bold'"></app-headline>
        <app-headline [title]="'results for your search'" [type]="'h6'" [class]="'text-secondary'"></app-headline>
      </div>
    </div>
  </div>

  <div class="custom-scrollbar overflow-y-auto mb-2">
    <div class="card mb-3">
      <div class="card-body p-3">
        <div class="d-flex flex-column">
          <div class="d-flex align-items-center justify-content-end mb-3 gap-2">
            <app-form-button [text]="'COMMUNITYNEWDISCUSSION' | translate" (click)="createDiscussion()" [icon]="'comment'" [iconPosition]="'right'" [cssClass]="'e-primary fw-semibold'" [iconClass]="'fs-5'"></app-form-button>
          </div>
          <div class="d-flex align-items-center">
            <ejs-breadcrumb [enableNavigation]="false" [maxItems]=2 overflowMode="Menu" [enableActiveItemNavigation]="true">
              <e-breadcrumb-items>
                <e-breadcrumb-item iconCss="e-icons e-home mb-1" url="../"></e-breadcrumb-item>
                <e-breadcrumb-item text="Getting" url="./breadcrumb/getting-started"></e-breadcrumb-item>
                <e-breadcrumb-item text="Data-Binding" url="./breadcrumb/data-binding"></e-breadcrumb-item>
                <e-breadcrumb-item text="Icons" url="./breadcrumb/icons"></e-breadcrumb-item>
                <e-breadcrumb-item text="Navigations" url="./breadcrumb/navigations"></e-breadcrumb-item>
                <e-breadcrumb-item text="Templates" url="./breadcrumb/templates"></e-breadcrumb-item>
                <e-breadcrumb-item text="Discover the world of fine arts" url="./breadcrumb/overflow"></e-breadcrumb-item>
              </e-breadcrumb-items>
              <ng-template #separatorTemplate>
                <app-icon-badge [style]="'default'" [icon]="'chevron_right'" [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
              </ng-template>
            </ejs-breadcrumb>
          </div>

          <div class="d-flex mt-2">
            <div class="d-flex align-items-center gap-2 flex-wrap">
              <app-headline [title]="'Discussions in: '" [type]="'h6'" [class]="'text-primary fw-bold'"></app-headline>
              <app-headline [title]="'Name of Parent Topic'" [type]="'h6'" [class]="'text-muted fw-bold'"></app-headline>
            </div>
          </div>
          <div class="d-flex align-items-center flex-wrap justify-content-between my-2">
            <div class="d-flex align-items-center">
              <app-form-button (click)="true" [text]="('COMMUNITYDISCUSSIONMARKALLASREAD' | translate)" [cssClass]="'e-btn e-flat fs-default text-muted fw-bold p-1'" [icon]="'playlist_add_check'" [iconClass]="'fs-4 mts-icon-filled m-1'"></app-form-button>
            </div>
            <div class="d-flex align-items-center">
              <app-form-dropdown
                [fG]="communityDiscussionForm"
                [fCN]="'discussion_filter'"
                [dataSource]="discussionFilterOptions"
                [placeholder]="'SELECTFILTER' | translate"
                [icon]="'filter_list'"
                [popupWidth]="'auto'"
                [cssClass]="'small-filter-dropdown'">
              </app-form-dropdown>
            </div>
          </div>
          <!-- TILES FOR DISCUSSION CONTAINER -->
          <div class="discussion-tiles d-flex flex-wrap gap-2 justify-content-start align-items-stretch">
            <!-- Tile Discussion Unread-->
            <div class="card unread d-flex flex-column flex-fill cursor-pointer">
              <div class="card-body p-card pt-1">
                <div class="d-flex justify-content-end align-items-center">
                  <div class="dropdown">
                    <div data-bs-toggle="dropdown" aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                      <app-icon-badge [style]="'notification'" [icon]="'more_vert'" [fontSize]="'fs-5'"></app-icon-badge>
                    </div>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li><app-link [title]="('COMMUNITYDISCUSSIONMARKASREAD' | translate)" [style]="'dropdown'">{{ ('COMMUNITYDISCUSSIONMARKASREAD' | translate) }}</app-link></li>
                      <li><app-link [title]="('COMMUNITYDISCUSSIONPIN' | translate)" [style]="'dropdown'">{{ ('COMMUNITYDISCUSSIONPIN' | translate) }}</app-link></li>
                      <li><hr class="dropdown-divider"></li>
                      <li><app-link [title]="('COMMUNITYDISCUSSIONEDIT' | translate)" [style]="'dropdown'">{{ ('COMMUNITYDISCUSSIONEDIT' | translate) }}</app-link></li>
                      <li><app-link [title]="('COMMUNITYDISCUSSIONDELETE' | translate)" [style]="'dropdown'">{{ ('COMMUNITYDISCUSSIONDELETE' | translate) }}</app-link></li>
                    </ul>
                  </div>
                </div>
                <div class="heading-menu-container d-flex align-items-center gap-3 pt-3">
                  <div class="d-flex align-items-center position-relative">
                    <app-avatar [image]="'https://ej2.syncfusion.com/demos/src/grid/images/2.png'" [name]="'Stefan Dragosici'" [type]="'large'" [icon]="'person'" [border]="false"></app-avatar>
                    <div class="position-absolute top-0 start-100 translate-middle p-1">
                      <app-icon-badge [style]="'default'" [icon]="'keep'" [fontSize]="'fs-6'" [fontColor]="'text-white'" [class]="'bg-bright-yellow rounded-pill px-1 mts-icon-filled'"></app-icon-badge>
                    </div>
                  </div>
                  <app-headline [title]="'What are the best techniques for improving low-light smartphone photos?'" [type]="'h6'" [class]="'fw-bold truncate-text-three-lines'"></app-headline>
                </div>
                <div class="d-flex align-items-center">
                  <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-muted'" [class]="'fst-italic'">Posted 13.07.2024</app-content>
                </div>
                <!-- Description -->
                <div class="description-container my-3">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'" [truncateLines]="4">Evaluate management efficiency by completing this survey, lorem ipsum dolor. Evaluate management efficiency by completing this survey, lorem ipsum dolor.</app-content>
                </div>
                <div class="bottom-container d-flex align-items-center flex-wrap w-100 gap-3">
                  <div class="comment_button d-flex align-items-center bg-secondary border rounded-pill p-1 gap-2">
                    <app-avatar [image]="'https://ej2.syncfusion.com/demos/src/grid/images/2.png'" [name]="'Stefan Dragosici'" [type]="'small'" [border]="false"></app-avatar>
                    <div class="pe-3">
                      <app-content [fontSize]="'fs-default'" [fontColor]="'text-white'">Comment here</app-content>
                    </div>
                  </div>
                  <div class="d-flex align-items-center justify-content-end gap-2 ms-auto">
                    <div class="user_count d-flex align-items-center gap-1 p-1">
                      <app-icon-badge [style]="'default'" [icon]="'person'" [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                      <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'" [fontDecoration]="'fw-bold'">1.2k</app-content>
                    </div>
                    <div class="likes_count d-flex align-items-center gap-1 p-1">
                      <app-icon-badge [style]="'default'" [icon]="'thumb_up'" [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                      <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'" [fontDecoration]="'fw-bold'">365</app-content>
                    </div>
                    <div class="views_count d-flex align-items-center gap-1 p-1">
                      <app-icon-badge [style]="'default'" [icon]="'visibility'" [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                      <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'" [fontDecoration]="'fw-bold'">165</app-content>
                    </div>
                    <div class="share_disscution d-flex align-items-center gap-1 p-1">
                      <app-icon-badge [style]="'default'" [icon]="'share'" [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Discussion Created by Me-->
            <div class="card d-flex flex-column flex-fill cursor-pointer">
              <div class="card-body p-card pt-1">
                <div class="d-flex justify-content-end align-items-center">
                  <div class="dropdown">
                    <div data-bs-toggle="dropdown" aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                      <app-icon-badge [style]="'notification'" [icon]="'more_vert'" [fontSize]="'fs-5'"></app-icon-badge>
                    </div>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li><app-link [title]="('COMMUNITYDISCUSSIONMARKASREAD' | translate)" [style]="'dropdown'">{{ ('COMMUNITYDISCUSSIONMARKASREAD' | translate) }}</app-link></li>
                      <li><app-link [title]="('COMMUNITYDISCUSSIONPIN' | translate)" [style]="'dropdown'">{{ ('COMMUNITYDISCUSSIONPIN' | translate) }}</app-link></li>
                      <li><hr class="dropdown-divider"></li>
                      <li><app-link [title]="('COMMUNITYDISCUSSIONEDIT' | translate)" [style]="'dropdown'">{{ ('COMMUNITYDISCUSSIONEDIT' | translate) }}</app-link></li>
                      <li><app-link [title]="('COMMUNITYDISCUSSIONDELETE' | translate)" [style]="'dropdown'">{{ ('COMMUNITYDISCUSSIONDELETE' | translate) }}</app-link></li>
                    </ul>
                  </div>
                </div>
                <div class="heading-menu-container d-flex align-items-center gap-3 pt-3">
                  <div class="d-flex align-items-center position-relative">
                    <app-avatar [image]="'https://ej2.syncfusion.com/demos/src/grid/images/2.png'" [name]="'Stefan Dragosici'" [type]="'large'" [icon]="'person'" [border]="false"></app-avatar>
                    <div class="position-absolute top-0 start-100 translate-middle p-1">
                      <app-icon-badge [style]="'default'" [icon]="'keep'" [fontSize]="'fs-6'" [fontColor]="'text-white'" [class]="'bg-bright-yellow rounded-pill px-1 mts-icon-filled'"></app-icon-badge>
                    </div>
                  </div>
                  <app-headline [title]="'What are the best techniques for improving low-light smartphone photos?'" [type]="'h6'" [class]="'fw-bold truncate-text-three-lines'"></app-headline>
                </div>
                <div class="d-flex align-items-center">
                  <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-muted'" [class]="'fst-italic'">Posted 13.07.2024</app-content>
                </div>
                <!-- Description -->
                <div class="description-container my-3">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'" [truncateLines]="4">Evaluate management efficiency by completing this survey, lorem ipsum dolor. Evaluate management efficiency by completing this survey, lorem ipsum dolor.</app-content>
                </div>
                <div class="bottom-container d-flex align-items-center flex-wrap w-100 gap-3">

                  <div class="d-flex align-items-center justify-content-end gap-2 ms-auto">
                    <div class="user_count d-flex align-items-center gap-1 p-1">
                      <app-icon-badge [style]="'default'" [icon]="'person'" [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                      <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'" [fontDecoration]="'fw-bold'">1.2k</app-content>
                    </div>
                    <div class="likes_count d-flex align-items-center gap-1 p-1">
                      <app-icon-badge [style]="'default'" [icon]="'thumb_up'" [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                      <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'" [fontDecoration]="'fw-bold'">365</app-content>
                    </div>
                    <div class="views_count d-flex align-items-center gap-1 p-1">
                      <app-icon-badge [style]="'default'" [icon]="'visibility'" [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                      <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'" [fontDecoration]="'fw-bold'">165</app-content>
                    </div>
                    <div class="share_disscution d-flex align-items-center gap-1 p-1">
                      <app-icon-badge [style]="'default'" [icon]="'share'" [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card d-flex flex-column flex-fill cursor-pointer">
              <div class="card-body p-card pt-1">
                <div class="d-flex justify-content-end align-items-center">
                  <div class="dropdown">
                    <div data-bs-toggle="dropdown" aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                      <app-icon-badge [style]="'notification'" [icon]="'more_vert'" [fontSize]="'fs-5'"></app-icon-badge>
                    </div>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li><app-link [title]="('COMMUNITYDISCUSSIONMARKASREAD' | translate)" [style]="'dropdown'">{{ ('COMMUNITYDISCUSSIONMARKASREAD' | translate) }}</app-link></li>
                      <li><app-link [title]="('COMMUNITYDISCUSSIONPIN' | translate)" [style]="'dropdown'">{{ ('COMMUNITYDISCUSSIONPIN' | translate) }}</app-link></li>
                      <li><hr class="dropdown-divider"></li>
                      <li><app-link [title]="('COMMUNITYDISCUSSIONEDIT' | translate)" [style]="'dropdown'">{{ ('COMMUNITYDISCUSSIONEDIT' | translate) }}</app-link></li>
                      <li><app-link [title]="('COMMUNITYDISCUSSIONDELETE' | translate)" [style]="'dropdown'">{{ ('COMMUNITYDISCUSSIONDELETE' | translate) }}</app-link></li>
                    </ul>
                  </div>
                </div>
                <div class="heading-menu-container d-flex align-items-center gap-3 pt-3">
                  <div class="d-flex align-items-center position-relative">
                    <app-avatar [image]="'https://ej2.syncfusion.com/demos/src/grid/images/2.png'" [name]="'Stefan Dragosici'" [type]="'large'" [icon]="'person'" [border]="false"></app-avatar>
                    <div class="position-absolute top-0 start-100 translate-middle p-1">
                      <app-icon-badge [style]="'default'" [icon]="'keep'" [fontSize]="'fs-6'" [fontColor]="'text-white'" [class]="'bg-bright-yellow rounded-pill px-1 mts-icon-filled'"></app-icon-badge>
                    </div>
                  </div>
                  <app-headline [title]="'What are the best techniques for improving low-light smartphone photos?'" [type]="'h6'" [class]="'fw-bold truncate-text-three-lines'"></app-headline>
                </div>
                <div class="d-flex align-items-center">
                  <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-muted'" [class]="'fst-italic'">Posted 13.07.2024</app-content>
                </div>
                <!-- Description -->
                <div class="description-container my-3">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'" [truncateLines]="4">Evaluate management efficiency by completing this survey, lorem ipsum dolor. Evaluate management efficiency by completing this survey, lorem ipsum dolor.</app-content>
                </div>
                <div class="bottom-container d-flex align-items-center flex-wrap w-100 gap-3">

                  <div class="d-flex align-items-center justify-content-end gap-2 ms-auto">
                    <div class="user_count d-flex align-items-center gap-1 p-1">
                      <app-icon-badge [style]="'default'" [icon]="'person'" [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                      <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'" [fontDecoration]="'fw-bold'">1.2k</app-content>
                    </div>
                    <div class="likes_count d-flex align-items-center gap-1 p-1">
                      <app-icon-badge [style]="'default'" [icon]="'thumb_up'" [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                      <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'" [fontDecoration]="'fw-bold'">365</app-content>
                    </div>
                    <div class="views_count d-flex align-items-center gap-1 p-1">
                      <app-icon-badge [style]="'default'" [icon]="'visibility'" [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                      <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'" [fontDecoration]="'fw-bold'">165</app-content>
                    </div>
                    <div class="share_disscution d-flex align-items-center gap-1 p-1">
                      <app-icon-badge [style]="'default'" [icon]="'share'" [fontSize]="'fs-5'" [fontColor]="'text-muted'"></app-icon-badge>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
